import Coordinate from "./Coordinate";

export default class RotateCoordinate extends Coordinate {
    constructor(provider, parent, absX, absY) {
        super(provider, absX, absY);
        this.parent = parent;
    }

    display(g) {
        g.stroke(0);
        g.strokeWeight(1);
        g.fill(200, 0, 200); // purple
        g.ellipse(this.currentX, 0, this.size);
    }

    drag(dx, dy) {
        let angle = this.parent.center.angleTo(this.view.coordinate);
        let quarterTurns = angle / (this.p.HALF_PI / 2); // ex -1.012
        let roundedQuarterTurns = Math.round(quarterTurns); // ex -1
        let leftOver = Math.abs(quarterTurns - roundedQuarterTurns); // ex 0.012
        this.parent.rotation = leftOver < 0.1
            ? roundedQuarterTurns * (this.p.HALF_PI / 2)
            : angle;
    }

    move(dx, dy, withUpdate = true) {
        // if (dx == 0 && dy == 0) {
        //     return;
        // }
        // if (withUpdate) {
        //     let angle = this.parent.center.angleTo(this.view.coordinate);
        //     let quarterTurns = angle / (this.p.HALF_PI / 2); // ex -1.012
        //     let roundedQuarterTurns = Math.round(quarterTurns); // ex -1
        //     let leftOver = Math.abs(quarterTurns - roundedQuarterTurns); // ex 0.012
        //     this.parent.rotation = leftOver < 0.1
        //         ? roundedQuarterTurns * (this.p.HALF_PI / 2)
        //         : angle;
        // }
    }

    mouseOver(viewX, viewY) {
        if (!this.hovered(viewX, viewY)) {
            return false;
        }

        this.cursor.move();
        return true;
    }

    hovered(viewX, viewY) {
        let d = this.p.dist(this.currentX, 0, viewX, viewY);
        return d < this.size / 2;
    }

    get currentX() {
        return Math.min(this.parent.currentMaxSize, this.parent.currentWidth / 2 + 60);
    }
}
